import React from 'react';

import PurchaseOrderEdit from '@components/shared/purchaseOrders/PurchaseOrderEdit';
import purchaseOrderService from '@services/admin/purchaseOrderService';
import supplierService from '@services/admin/supplierService';
import productService from '@services/admin/productService';

export default function AdminPurchaseOrderNew() {
  return (
    <PurchaseOrderEdit
      service={purchaseOrderService}
      supplierService={supplierService}
      productService={productService}
      role="admin"
    />
  );
}
